export function isSongLockedForGuest(songId: string) {
  let hash = 0;

  for (let index = 0; index < songId.length; index += 1) {
    hash = (hash * 31 + songId.charCodeAt(index)) | 0;
  }

  return Math.abs(hash) % 3 !== 0;
}
